import React from 'react'

import {StyledCard, CardIcon} from './InfoCard.styled'

import {Icon, IconName} from '~/components/general/icon/Icon'
import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {theme} from '~/styles/theme'

type InfoCardProps = {
  title: string
  icon?: IconName
  content: string
  spaceAfter?: boolean
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  icon = 'Info',
  content,
  spaceAfter,
}) => (
  <StyledCard spaceAfter={spaceAfter}>
    <Container flex direction="column" align="flex-start" spacing={2}>
      <Container flex align="center" spacing={2}>
        <CardIcon>
          <Icon name={icon} size="md" />
        </CardIcon>
        <Typography size="lg" weight="medium">
          {title}
        </Typography>
      </Container>
      <Typography color={theme.colors.grey.main}>{content}</Typography>
    </Container>
  </StyledCard>
)
